import React from "react";
import SampleOrders from "shared/sample-orders";

function StartupsSampleOrders(props) {
  const newProps = { ...props, isMerchant: false };
  return <SampleOrders {...newProps} />;
}

export default StartupsSampleOrders;
